import React from "react";
import { Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
const refreshIcon = require("assets/img/icons/refresh.png");

export const FiltrosEVS = ({ control, onRefresh, resetPage, searchPlaceholder }) => {
    return (
        <div className="formulario-fields-row align-items-end">
            <div className="formulario-field">
                <label htmlFor="search" className="m-0">
                    Buscar
                </label>
                <Controller
                    name="search"
                    control={control}
                    render={({ field }) => (
                        <input
                            type="text"
                            className="form-control"
                            placeholder={searchPlaceholder}
                            value={field.value}
                            onChange={(e) => {
                                field.onChange(e.target.value);
                                resetPage();
                            }}
                        />
                    )}
                />
            </div>
            <img
                src={refreshIcon}
                alt="Refrescar listado"
                title="Refrescar listado"
                className="action_img mb-1"
                onClick={() => {
                    onRefresh();
                }}
            />
        </div>
    );
};
